import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import './StatusIndicator.css';

const StatusIndicator = ({ user }) => {
    const [status, setStatus] = useState('Basic');

    useEffect(() => {
        if (!user?.uid) return;
        
        const unsubscribe = onSnapshot(
            doc(db, 'users', user.uid),
            (doc) => {
                if (doc.exists()) {
                    const userData = doc.data();
                    
                    // Check for new role-based system first, then fallback to legacy boolean
                    const isProUser = userData.role === 'pro_user' || userData.isPro === true;
                    const newStatus = isProUser ? 'Pro' : 'Basic';
                    setStatus(newStatus);
                }
            },
            (error) => {
                console.error("Error fetching user status:", error);
            }
        );

        return () => unsubscribe();
    }, [user]);

    return (
        <div className={`status-indicator ${status.toLowerCase()}`}>
            Logged In - {status}
        </div>
    );
};

export default StatusIndicator;
